import { useReveal } from "@/hooks/useReveal";

export default function ExportArgument() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section className="bg-cream py-20 md:py-24">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Why the certification is the point
          </h2>
          <p className="mt-5 text-ink/75 text-lg leading-relaxed">
            If you sell only into the domestic market, our certification is a
            nice attribute and you can reasonably buy a cheaper ingredient. If
            you export finished product to the European Union or the United
            States with an organic claim on the pack, it stops being an
            attribute. The ingredient has to be certified under a regime valid
            in the destination, and it has to be documented well enough to
            survive your certifier&apos;s audit of the chain behind it. That is
            the situation this supply is built for, and it is the one where the
            price difference stops being a premium and becomes the cost of the
            market you are selling into.
          </p>
        </div>
      </div>
    </section>
  );
}